<template>
  <div class="head">
    <div class="ctb_icon"></div>
    <h2>穿梭巴士後臺管理系統</h2>
    <div class="right_fn">
      <div class="email none" @click="go_email">
        <img src="../../images/email_icon.png" alt=""/>
      </div>

      <div class="user">
        <img src="../../images/head_photo.png" alt="用戶頭像"/>
        <span>{{ name }}</span>

        <div class="headerMenus">
          <div class="item" @click="showChangePwd=true">
            修改密碼
          </div>
          <div class="item" @click="logout">
            退出登錄
          </div>
        </div>
      </div>
      <!-- 修改密碼彈框 -->
      <changePwd v-if="showChangePwd" @logout="logout" @closeChangePwdBox="closeChangePwdBox"/>
    </div>
  </div>
</template>
<script>
import changePwd from "@/components/change_pwd/index.vue";

export default {
  data()
  {
    return {
      showChangePwd: false,
      name: "",
    }
  },
  mounted()
  {
    let that = this;
    if(this.getCookie("admin_name"))
    {
      this.name = this.getCookie("admin_name");
    }
    else
    {
      this.reLogin(function() {
        that.name = that.getCookie("admin_name");
      });
    }
  },
  methods: {
    go_email()
    {
      // this.$router.push("/ekjt_manage/email_index");
    },
    // 關閉修改密碼彈框
    closeChangePwdBox()
    {
      return this.showChangePwd = false
    },
    //退出登錄
    async logout(options = {showTips: true})
    {
      //是否要提示
      if(options.showTips)
      {
        // console.log(userInfo);
        await this.$confirm(`確認登出系統嗎?`, '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        })
      }

      //清空jwt
      this.$store.commit('token', "");
      //保存用戶信息
      this.$store.commit('setUserInfo', {});
      // window.sessionStorage.setItem('token', response.data.jwt);
      window.localStorage.setItem('token', "");
      //保存管理員ID和名稱
      this.setCookie("admin_name", "");//管理員名稱
      this.setCookie("accountId", "")//管理員ID
      this.$notify({title: '成功', message: '登出成功', type: 'success'});

      //跳轉到登錄頁面
      this.$router.push("/login");
    },
  },
  components: {
    changePwd
  },
}
</script>
<style lang="less" scoped>

.head {
  width: 100%;
  height: 0.9rem;
  border-bottom: 1px solid #e8e8e8;
}

.head .right_fn {
  height: 100%;
  display: flex;
  align-items: center;
}

.head .email {
  width: 0.44rem;
  height: 0.44rem;
  cursor: pointer;
  position: relative;
  font-size: 0;
  text-align: center;
}

.head .email:hover {

  background-color: #e9f3fd;
  border-radius: 50%;
}

.head .email img {
  width: 0.28rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.head .ctb_icon {
  width: 1.46rem;
  height: 0.6rem;
  background: url("../../images/ctb_logo.png") no-repeat;
  background-size: 100% 100%;
  float: left;
  margin-left: 0.73rem;
  margin-top: 0.1rem;
}

.head h2 {
  font-size: 0.24rem;
  float: left;
  margin-left: 0.52rem;
  margin-top: 0.29rem;
}

.head .right_fn {
  float: right;
}

.head .user {
  position: relative;
  margin-left: 0.4rem;
  line-height: 0.44rem;
  cursor: pointer;
}

.head .user img {
  max-width: 0.44rem;
  max-height: 0.44rem;
  margin-right: 0.19rem;
  vertical-align: middle;
}

.head .user span {
  font-size: 0.2rem;
  margin-right: 0.83rem;
  display: inline-block;
  /* padding-top: 0.31rem; */
}

.head .user {
  height: 100%;
  display: flex;
  align-items: center;

  &:hover {
    .headerMenus {
      opacity: 1;
      display: flex;
    }
  }

  .headerMenus {
    z-index: 100;
    position: absolute;
    width: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    display: none;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background-color: rgba(0, 0, 0, .8);
    color: white;
    border-radius: 3px;
    overflow: hidden;
    opacity: 0;
    transition: all .2s ease-in-out;

    .item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      &:hover {
        background-color: rgba(255, 255, 255, .2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/airport_passenger_lists/commpnents/header.vue